import React from "react";
import SwitchToggle from "../../components/SwitchToggle";
import { useNavigate, useLocation } from "react-router-dom";

const ViewBadge = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // Static fallback data
  const badge =
    (location.state && location.state.badge) || {
      title: "Consistency King",
      image: "/static/images/workout1.webp",
      description: "Complete 10 workouts in a month",
      criteriaType: "Workouts",
      targetValue: "10",
      usageLimit: "custom",
      customLimit: "3",
      eligibleUsers: "All Users",
      status: true,
      createdDate: "30 July 2025",
    };

  // Usage limit text
  const getUsageLimitDisplay = () => {
    return badge.usageLimit === "custom" ? badge.customLimit : badge.usageLimit;
  };

  // Unlock target always uses ≥
  const getUnlockTarget = () => {
    if (badge.criteriaType && badge.targetValue) {
      return `${badge.criteriaType} ≥ ${badge.targetValue}`;
    }
    return "";
  };

  return (
    <div className="view-badge-page">
      <div className="main_title">
        <h1>Badge Details</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> -{" "}
          <button onClick={() => navigate("/manage-badges")}>
            Manage Achievements & Badges
          </button>{" "}
          - View Badge
        </p>
      </div>

      <div className="cards">
        <div className="view_page">
          <div className="gap_p">

            {/* Badge Image */}
            <div className="w_33">
              <h6>Badge Image</h6>
              <img  src="/static/images/workout1.webp"  alt={badge.title}
                style={{ width: "50%", objectFit: "contain" }}
              />
            </div>

            {/* Title */}
            <div className="w_33">
              <h6>Badge Title</h6>
              <p>{badge.title}</p>
            </div>

            {/* Description */}
            <div className="w_33">
              <h6>Description</h6>
              <p>{badge.description}</p>
            </div>

            {/* Criteria Type */}
            <div className="w_33">
              <h6>Criteria Type</h6>
              <p>Calories Burned</p>
            </div>

            {/* Target Value */}
            <div className="w_33">
              <h6>Target Value</h6>
              <p>10</p>
            </div>

            {/* Unlock Criteria */}
            <div className="w_33">
              <h6>Unlock Criteria / Target</h6>
              <p>2000</p>
            </div>

            {/* Usage Limit */}
            <div className="w_33">
              <h6>Usage Limit</h6>
              <p>5 times</p>
            </div>

            {/* Eligible Users */}
            <div className="w_33">
              <h6>Eligible Users</h6>
              <p>All Users</p>
            </div>

            {/* Created Date */}
            <div className="w_33">
              <h6>Created Date</h6>
              <p>30 July 2025</p>
            </div>

            {/* Status */}
            <div className="w_33">
              <h6>Status</h6>
              <SwitchToggle defaultChecked={badge.status} />
            </div>

          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewBadge;
